var map = {
	"./en.png": 260,
	"./fb.png": 7151,
	"./hand.png": 6418,
	"./historiatlo.png": 6678,
	"./ig.png": 1149,
	"./logo-pc.png": 2855,
	"./logo.png": 6949,
	"./logofirmy1.png": 9433,
	"./logofirmy11.png": 7312,
	"./logoround.png": 5566,
	"./logout.png": 6645,
	"./multi.png": 54,
	"./payment/payment-banner.png": 8758,
	"./payment/pub_crime_logo.png": 5459,
	"./payment/tlo-karteczka.png": 4661,
	"./pl.png": 3743,
	"./rankingtlo-flip.png": 2307,
	"./rankingtlo.png": 5514,
	"./refresh.png": 9046,
	"./robocze/pin.png": 1118,
	"./robocze/pranie.png": 8823,
	"./single.png": 1444,
	"./teambar.png": 1387,
	"./trash.png": 8849,
	"./z apki/hand.png": 253,
	"./z apki/historiatlo.png": 9136,
	"./z apki/logoround.png": 897,
	"./z apki/multi.png": 5798,
	"./z apki/notifiicon.png": 2588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;